import { TaskType } from '@/shared/domain/taskTypes';

/** Shown when the training metric was computed over every label. */
export const OPTIMIZE_ON_ALL_LABELS = 'All labels';

/**
 * Value of the Model Details "Training Params" -> "Optimize on" metric.
 *
 * The trainer reads `model_evaluation_arguments.rare_class_label` on the
 * distillation event: a label name means the optimisation metric was computed
 * for that label only, unset means all labels. The option exists only for
 * single-label classification (the Train page offers it nowhere else), so
 * multi-label, NER and generative versions get `null` and no row.
 *
 * Reads the label stored on the event rather than the usecase's current
 * labels: Model Details describes the run as it happened, and a label renamed
 * since then should still show the name it was trained with.
 *
 * @param {object|null|undefined} distillationEvent `details.distillation_event`
 * @param {string} taskType the version's task type (`TaskType.*`)
 * @returns {string|null} label name, `OPTIMIZE_ON_ALL_LABELS`, or `null` when
 *   the row does not apply
 */
export function optimizeOnDisplay(distillationEvent, taskType) {
  if (taskType !== TaskType.classification) return null;
  if (distillationEvent?.is_multilabel) return null;
  const label = distillationEvent?.model_evaluation_arguments?.rare_class_label;
  // A label can be a falsy-looking string like "0"; check presence, not truthiness.
  return label != null && String(label) !== '' ? String(label) : OPTIMIZE_ON_ALL_LABELS;
}
